import React from 'react'
import therapy from "../assets/therapy.png"
import {
  CalendarCheck,
  Clock,
  ChatDots,
  ArrowRight
} from 'react-bootstrap-icons'

export default function Approach() {
  return (
    <section id="approach" className="py-5 section-tint approachSection">
      <div className="container">

        {/* heading */}
        <div className="text-center mb-5">
          <div className="eyebrowWrap justify-content-center">
            <span className="eyebrowLine"></span>
            <p className="aboutEyebrow mb-0">HOW I CAN SUPPORT YOU</p>
            <span className="eyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-2">Approach</h1>

          <p className="approachHeadingIntro mb-0">
            A calm, structured, and supportive process tailored to you.
          </p>
        </div>

        <div className="row align-items-center g-5">

          {/* LEFT */}
          <div className="col-12 col-lg-7">
            <div className="approachCard">

              {/* intro */}
              <div className="approachRow">
                <div className="approachRowIcon">
                  <CalendarCheck />
                </div>

                <p className="approachIntro mb-0">
                  I currently offer online sessions, with availability in the
                  evenings, on Friday mornings, and some limited weekend slots.
                </p>
              </div>

              <div className="approachDivider"></div>

              {/* what to expect */}
              <div className="approachRow align-items-start">
                <div className="approachRowIcon">
                  <ChatDots />
                </div>

                <div>
                  <div className="approachLabel mb-2">
                    What to expect
                  </div>

                  <div className="approachText">
                    I offer a complimentary 30-minute initial consultation.
                    This gives us the opportunity to meet, explore your needs,
                    and for you to ask questions to see if we are the right fit.

                    <br /><br />

                    Following this, sessions are 50 minutes long and focus on what
                    brings you to therapy, at a pace that feels right for you.
                  </div>
                </div>
              </div>

              <div className="approachDivider"></div>

              {/* flow */}
              <div className="approachFlow">
                <div className="approachFlowItem">
                  <ArrowRight />
                  <span>Free 30-minute consultation</span>
                </div>

                <div className="approachFlowItem">
                  <Clock />
                  <span>50-minute ongoing sessions</span>
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT IMAGE (no card) */}
          <div className="col-12 col-lg-5 text-center">
            <img
              src={therapy}
              alt="Therapy session"
              className="approachImage"
            />
          </div>

        </div>
      </div>
    </section>
  )
}